var path = '/PrehistoricFeatureAssemblage/'

function get (http, id) {
    return http.get(path + `Get?id=${id}&getComponents=true`)
}
function put (http, assemblageDto) {
    return http.put(path + '?saveComponents=true', assemblageDto)
}
function search (http, searchDto) {
    return http.post(path + 'Search?getComponents=true', searchDto)
}

function getPrehistoricAgeList () {
    return [
        {prehistoricAgeId: 1, description: 'Unknown Prehistoric'},
        {prehistoricAgeId: 2, description: 'Paleoindian'},
        {prehistoricAgeId: 3, description: 'Early Archaic'},
        {prehistoricAgeId: 4, description: 'Middle Archaic'},
        {prehistoricAgeId: 5, description: 'Late Archaic'},
        {prehistoricAgeId: 6, description: 'General Archaic'},
        {prehistoricAgeId: 7, description: 'Late Prehistoric'},
        {prehistoricAgeId: 8, description: 'Protohistoric'}
    ]
}

export default {
    get: get,
    put: put,
    search: search,
    getPrehistoricAgeList: getPrehistoricAgeList
}



// WEBPACK FOOTER //
// ./src/services/siteForm/prehistoricFeatureService.js